import { marked } from 'marked';
import PlainTextRenderer from 'marked-plaintext';
const markedPlainTextRenderer = new PlainTextRenderer();
const options = {
    renderer: markedPlainTextRenderer,
    mangle: false,
};
export default function markdownToText(markdown) {
    return marked(markdown, options).trim();
}
